import { render, staticRenderFns } from "./reward-setting.vue?vue&type=template&id=ab67b540&scoped=true&"
import script from "./reward-setting.vue?vue&type=script&lang=js&"
export * from "./reward-setting.vue?vue&type=script&lang=js&"
import style0 from "./reward-setting.vue?vue&type=style&index=0&id=ab67b540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab67b540",
  null
  
)

export default component.exports